import Centered from './Centered';
import Split from './Split';

export default { Centered, Split };
